export enum KindOfFlow {
  REQUEST = 'richieste',
  AUTOLECTURE = 'autoletture'
}

export interface Elaboration {
  IdFile?: string;
  NomeFile?: string;
  FormatoFile?: string;
  CodiceServizio?: string;
  CodiceFlusso?: string;
  LineaProdotto?: string;
  CodiceLineaProdotto?: string;
  DescrizioneLineaProdotto?: string;
  IdDistribuzione?: string;
  IdVendita?: string;
  Canale?: string;
  DataInserimento?: string;
  StatoElaborazione?: string;
  DataElaborazioneInizio?: string;
  DataElaborazioneFine?: string;
  RichiesteTotali?: number;
  RichiesteAmmissibili?: number;
  RichiesteNonAmmissibili?: number;
  RichiesteInAttesaAmmissibilita?: number;
  RichiesteNonElaborate?: number;
  SezioneCaricamento?: string;
}

export interface ElaborationTableRow extends Elaboration {
  CodServizio_CodFlusso?: string;
}
